import React from 'react';
import * as FiIcons from 'react-icons/fi';

/**
 * Feature-level crash guard. Catches render-time errors thrown by children
 * and renders the `fallback` element (or a minimal built-in notice) instead
 * of blanking the whole page.
 *
 * Class component by necessity — React still requires one for
 * getDerivedStateFromError/componentDidCatch; everything else in this repo
 * stays functional components + hooks.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || 'Unknown error' };
  }

  componentDidCatch(error, info) {
    // Structured logging consumes this once B8/error-tracking exists.
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.fallback) return this.props.fallback;
    return (
      <div className="error-boundary" role="alert">
        <FiIcons.FiAlertTriangle aria-hidden="true" />
        <strong>Something crashed here</strong>
        <span>{this.state.message}</span>
      </div>
    );
  }
}

export default ErrorBoundary;
